import { getSpaceBasePath } from '../../components/NavigationSidebar/spacesNavPath';
import { toNavGroupName } from '../../hooks/useSpacesNavItems';
import type { LayoutSection, LayoutSpec } from '../../types/LayoutConfig';

type LayoutAddressable = Pick<LayoutSpec, 'id' | 'group'>;

export const getMobileLayoutBasePath = (sectionId: LayoutSection, layout: LayoutAddressable) =>
  getSpaceBasePath(sectionId, layout.group ? toNavGroupName(layout.group) : undefined, layout.id);

export const getMobileLayoutPanelRoute = (sectionId: LayoutSection, layout: LayoutAddressable, panelId: string) =>
  `${getMobileLayoutBasePath(sectionId, layout)}/${panelId}`;

export const getMobileLayoutPanelTabRoute = (
  sectionId: LayoutSection,
  layout: LayoutAddressable,
  panelId: string,
  tabId: string
) => `${getMobileLayoutPanelRoute(sectionId, layout, panelId)}/${encodeURIComponent(tabId)}`;
